module.exports = __webpack_public_path__ + "static/media/Banner_580x278.ffd92324.jpg";